import React, {useEffect} from "react";
import "./profileSection.scss";
import OrderHeadSectionComponent from "../../components/headSection/components/OrderHeadSectionComponent";
import ProfileSectionDataForm from "./components/ProfileSectionDataForm";
import ProfilePath from "./components/ProfilePath";
import ContactSectionComponent from "../../pages/main/sections/contactSection/ContactSectionComponent";

const ProfileComponent = () => {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className="profileComponent__container">
            <div className="mainSectionComponent__container-content-overlay"></div>
            <OrderHeadSectionComponent />
            <ProfilePath
                path={['Profile']}
                component="Profile"
            />
            <ProfileSectionDataForm />
            <ContactSectionComponent />
        </div>
    );
}

export default ProfileComponent;